module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Join-1-cb53e61328c8b03f4d2ff89d1886f40f74cc37ef162203f947474d00bb7f2069.svg";